import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FORM_VALUE, REIMBURSEMENT_ID } from '../../Cookies'
import { http } from '../../AxiosConfig'
import toast, { Toaster } from 'react-hot-toast'
import FormLoader from '../FormLoader/FormLoader'

const FinalCardComponent = () => {
  const [user, setUser] = useState(null)
  const [type, setType] = useState(null)
  const [linkStub, setLinkStub] = useState(null)

  const fetchReimbursement = () => {
    const rId = localStorage.getItem(REIMBURSEMENT_ID)
    http
      .get('/reimbursements/' + rId)
      .then(res => {
        // setType(res.data.data.attributes.reimbursement_items[0]?.type)
        setType(res.data.data.type)
        setLinkStub(res.data.data.attributes.link_stub)
        setUser(res.data.data.attributes.user)
      })
      .catch(err => {
        toast.error(
          `Something went wront. ${err.message}`,
          {
            duration: 6000,
          },
        )
      })

      .finally(() => {})
  }

  function refreshPage() {
    localStorage.removeItem(REIMBURSEMENT_ID)
    localStorage.removeItem(FORM_VALUE)
    window.location.reload(false)
    window.location.href = '/'
  }
  useEffect(() => {
    fetchReimbursement()
  }, [])

  if (user) {
    return (
      <div className="mt-20">
        <Toaster position="top-center" reverseOrder={false} />
        <article className="card" style={statementStyle}>
          Thanks <strong>{user.name}</strong>
          <p>
            Your reimbursement has been successfully submitted and is awaiting
            approval. If there is a problem, a member support coordinator will
            contact you.
          </p>
          <br></br>
          <p>
            Save this link to check on the progress of your &nbsp;
            {type.replace('_', ' ')} submission.
          </p>
          <div className="underline hover:underline text-cyan-700">
            <Link to={`/Status/${linkStub}`} target="_blank">
              My Reimbursement Link
            </Link>
          </div>
          <br></br>
          <button onClick={refreshPage} className="primary-button">
            Home
          </button>
        </article>
      </div>
    )
  }
  else {
    return <FormLoader message="Loading" />
  }
}
export default FinalCardComponent

const statementStyle = {
  paddingBottom: '70px',
}
